import { required, minLength, maxLength, onlyNumbers } from '../utils/fieldValidation';

const validate = values => {
  const errors = {};
  // MemberId Validation
  if (required(values.MemberId)) {
    errors.MemberId = 'errRegisMedID';
  }
  if (maxLength(20)(values.MemberId)) {
    errors.MemberId = 'errLoginUsrMaxReq';
  }

  // Accesscode validation
  if (required(values.AccessCode)) {
    errors.AccessCode = 'errSharedOTPReq';
  }
  if (minLength(6)(values.AccessCode)) {
    errors.AccessCode = 'errLoginPasMinReq';
  }
  if (maxLength(12)(values.AccessCode)) {
    errors.AccessCode = 'errLoginPasMaxReq';
  }
  if (onlyNumbers(values.AccessCode)) {
    errors.AccessCode = 'errLoginPassOnlyNum';
  }

  return errors;
};

export default validate;
